import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CollapsedBreadcrumbs, DropDownMenu } from 'common/components';
import { getProjectStatusOptions } from 'common/utils/helpers';

import ProjectDropDownSelector from './ProjectDropDownSelector';
import TitlePreview from './TitlePreview';

const HeaderSection = ({
    contactId,
    currentStatus,
    handleClickStatus,
    project,
    redirect,
    statusDictionary,
}) => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1}
            p={2}
            sx={{ mb: 2, pb: 0, width: '100%' }}
        >
            <ProjectDropDownSelector
                contactId={contactId}
                projectId={project?.id}
                currentProjectName={project?.name}
                onProjectChange={(newProjectId) =>
                    redirect(`/contacts/${contactId}/${newProjectId}`)
                }
            >
                <TitlePreview name={project?.name} />
            </ProjectDropDownSelector>

            <CollapsedBreadcrumbs
                current={project.name}
                locations={[
                    {
                        label: t('Contact_plural'),
                        action: () => redirect(`/contacts`),
                    },
                    {
                        label: project?.contact?.name || t('Contact'),
                        action: () => redirect(`/contacts/${contactId}`),
                    },
                ]}
            />
            <DropDownMenu
                alignRight
                defaultLabel={statusDictionary[currentStatus]?.label}
                defaultValue={currentStatus}
                handleSelected={handleClickStatus}
                itemsToSelect={getProjectStatusOptions().map((item) => ({
                    ...item,
                    icon: (
                        <CircleIcon
                            sx={{
                                color: item?.primary_color,
                                fontSize: 20,
                            }}
                        />
                    ),
                    iconPosition: 'left',
                }))}
                keyName="status"
                startIconButton={
                    <CircleIcon
                        sx={{
                            color: statusDictionary[currentStatus]
                                ?.primary_color,
                            fontSize: 20,
                        }}
                    />
                }
                sxButton={{
                    borderRadius: 0,
                    border: 0,
                    justifyContent: 'start',
                    '.MuiButton-endIcon': {
                        ml: 'auto',
                    },
                    width: '100%',
                    '&:hover': {
                        border: 0,
                        backgroundColor: 'transparent',
                    },
                }}
            />
        </Box>
    );
};

HeaderSection.propTypes = {
    contactId: PropTypes.string,
    currentStatus: PropTypes.string,
    handleClickStatus: PropTypes.func,
    project: PropTypes.object,
    redirect: PropTypes.func,
    statusDictionary: PropTypes.object,
};

export default HeaderSection;
